"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.defaultIPLocation = void 0;
exports.defaultIPLocation = {
    accuracyRadius: 0,
    city: '',
    continent: '',
    country: '',
    countryCode: '',
    isEU: false,
    latitude: '',
    longitude: '',
    subdivisions: [],
    state: '',
    stateprov: '',
    stateprovCode: '',
    timezone: '',
    usMetroCode: 0,
};
